import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Notification } from "./Notification";
import { useLocation, useHistory } from "react-router-dom";

function NewPassword() {
  const [error, setError] = useState();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const [loading, setLoading] = useState(false);
  const { newPassword } = useAuth();
  const history = useHistory();

  const search = useLocation().search;
  const token = new URLSearchParams(search).get("recoverToken");

  const handleNewPassword = (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const result = formValidation(passwordRef.current.value);
      if (!result) {
        setLoading(false);
        return;
      }
      newPassword(passwordRef.current.value, token).then((response) => {
        console.log(response);
        if (response === "şifre sıfırlandı") {
          history.push("/verified?result=Şifreniz değiştirildi");
        } else {
          history.push("/verified?result=Bir hata oluştu");
        }
      });
    } catch {
      console.log("failed to recover password");
    }
    setLoading(false);
  };

  const formValidation = (password) => {
    var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;

    if (!password.match(passw)) {
      setError(
        "Şifreniz rakam, büyük harf ve küçük harf içeren 6-20 karakter uzunluğunda oluşmalı"
      );
      return false;
    }
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      setError("Hatalı şifre tekrarı");
      return false;
    }
    return true;
  };

  return (
    <div className="login">
      <div className="login__container">
        <form onSubmit={handleNewPassword} className="login__form">
          <h1>YENI SIFRE OLUSTUR</h1>
          <div className="h5">
            <h5>YENI SIFRE</h5>
          </div>
          <div className="input">
            <input type="password" ref={passwordRef} required />
          </div>

          <div className="h5">
            <h5>YENI SIFRE TEKRARI</h5>
          </div>
          <div className="input">
            <input type="password" ref={passwordConfirmRef} required />
          </div>

          {error && <Notification notification={error} />}
          <div className="register__buttons">
            <div className="button">
              <button
                disabled={loading}
                type="submit"
                className="login__signInButton"
              >
                OLUSTUR
              </button>
            </div>
          </div>
          <div className="topLeftBorder">
            <div>
              <div className="borderTop"></div>
              <div className="borderLeft"></div>
            </div>
          </div>
          <div className="bottomRigtBorder">
            <div>
              <div className="borderRight"></div>
              <div className="borderBottom"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewPassword;
